import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { faqs } from '../data/coachSystem';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-white py-11 sm:py-14" aria-labelledby="faq-title" data-id="element-30" data-mp="1bmvbwt4ic0p4">
      <div className="mx-auto w-full max-w-[42rem] px-4 sm:px-6 lg:max-w-3xl" data-id="element-31" data-mp="1gjvkpbsqrhjx">
        <h2 id="faq-title" className="text-center font-display text-[1.6rem] leading-tight tracking-tight text-navy sm:text-[2rem]" data-id="element-32" data-mp="24ahdxwy36x9v">
          Frequently Asked Questions
        </h2>

        <ul className="mt-5 divide-y divide-navy-line border-y border-navy-line" data-id="element-33" data-mp="1uiv527981aaa">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} data-id="element-34" data-mp="2n6hbdn9u2t0u" data-mpi={index}>
                <h3 data-id="element-35" data-mp="2rys9ckl0k4qr">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-4 py-3.5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-navy" data-id="element-36" data-mp="2rzagic97s3dg">
                    <span className="text-[0.95rem] font-semibold leading-snug text-navy" data-id="element-37" data-mp="19t29l8fyzdeh">
                      {faq.question}
                    </span>
                    <PlusIcon className={`mt-0.5 h-4 w-4 shrink-0 text-teal transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-38" data-mp="1jkznwo29ylhf" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-39" data-mp="36gk30am67z5">
                  {isOpen ? <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-40" data-mp="3udaw1t6uwwv0">
                      <p className="pb-4 pr-6 text-[0.9rem] leading-relaxed text-navy-muted" data-id="element-41" data-mp="2c9npwixu3bpl">
                        {faq.answer}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}